module.exports = __webpack_public_path__ + "static/media/square-shadow.9f737551.png";